import { useState, useEffect } from 'react'

/**
 * This hook will run a function once, and only once, when the canLoad condition is true.
 * @param fn {function} loading fn to run
 * @param canLoad {boolean} whether or not to run the fn yet
 * @returns {boolean} whether or not the fn has run
 */
export const useFnOnce = (fn?: () => any, canLoad: boolean = true): boolean => {
  const [hasRun, setHasRun] = useState(false)
  const needsToRun = fn && canLoad && !hasRun

  useEffect(() => {
    if (needsToRun) {
      const returned = fn()
      if (typeof returned?.finally === 'function') {
        returned.finally(() => {
          setHasRun(true)
        })
      } else {
        setHasRun(true)
      }
    }
  }, [needsToRun, fn, canLoad])

  return hasRun
}
